import React from "react";
import { Skeleton } from "@ann/web-components";
import { SkeletonCardWrapper } from "./SkeletonCard.styled";

const SkeletonCard = ({ type = "folder", size = "medium" }) => {
  const getSkeletonDimensions = () => {
    if (type === "folder") {
      return {
        height: "120px",
        width: "100%",
      };
    } else if (type === "document") {
      return {
        height: "238px",
        width: "100%",
      };
    }
    return { height: "120px", width: "100%" };
  };

  const dimensions = getSkeletonDimensions();

  return (
    <SkeletonCardWrapper>
      <Skeleton
        height={dimensions.height}
        width={dimensions.width}
        size={size}
      />
    </SkeletonCardWrapper>
  );
};

export default SkeletonCard;
